// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__I6dXe","tableContainer":"Table_tableContainer__1wW8O","table":"Table_table__QeYV2","paginationWrapper":"Table_paginationWrapper__3CSXf"};